const GALLERY_PATH_PREFIXES = ["/floor-gallery/", "/admin/floor-gallery/"];

function isGalleryPath(pathname) {
  return GALLERY_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix));
}

/**
 * Make backend-provided gallery URLs host-aware for white-labeled domains.
 * We keep the path/query/hash, but use the current window origin.
 */
export function normalizeGalleryUrlForCurrentOrigin(galleryUrl) {
  if (!galleryUrl) return null;

  try {
    const fallbackOrigin =
      typeof window !== "undefined" ? window.location.origin : undefined;
    const parsed = new URL(galleryUrl, fallbackOrigin);

    if (!isGalleryPath(parsed.pathname)) {
      return parsed.href;
    }

    if (!fallbackOrigin) {
      return parsed.href;
    }

    return `${fallbackOrigin}${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch (error) {
    return galleryUrl;
  }
}

export default normalizeGalleryUrlForCurrentOrigin;
